export default __webpack_public_path__ + "static/levels-illus-7c1cb5b4ca29f2e404ef82bb308efb8c.png";